module.exports = __webpack_public_path__ + "static/img/case_tab_17.173859d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_tab_17.png
// module id = SF3s
// module chunks = 34